import { Text } from '@chakra-ui/layout';
import { Avatar, Badge, HStack } from '@chakra-ui/react';

export function UserAvatar({
  user,
  drn,
  label,
}: {
  user?: { displayName?: string; avatar?: string; role?: string } | null;
  drn: string | null;
  label: string;
}) {
  if (user === undefined) {
    return null;
  }
  return (
    <HStack>
      <Text fontSize="xs">{label}</Text>
      <Avatar key={drn} size="xs" name={user?.displayName} src={user?.avatar ?? undefined}></Avatar>
      <Text fontSize="sm" fontWeight="medium">
        {user?.displayName}
      </Text>
      <Badge colorScheme="yellow" variant="pill" fontWeight="semibold">
        {user?.role === 'STUDENT' ? 'Student' : 'EC'}
      </Badge>
    </HStack>
  );
}
